const images = document.querySelectorAll(".media-responses__image");
images.forEach(image => {
    image.firstElementChild.addEventListener("click", function(e){
        if (e.target.parentElement.classList.contains("media-responses__image--expand")) {
            e.target.parentElement.classList.remove("media-responses__image--expand");
        }
        else {
            e.target.parentElement.classList.add("media-responses__image--expand");
        }
    })
});
